import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { FacilityInventoryCountEditForm } from "application/facility-inventory/forms";
import { FacilityInventoryCountHeaderService } from "application/facility-inventory/services";
import { FacilityService } from 'application/facility/services';
import { action } from "mobx";
import _ from 'lodash';

class FacilityInventoryCountEditViewStore extends BaseEditViewStore {
	params = {
		id: this.rootStore.routerStore.routerState.params.id,
	};
	
	constructor(rootStore) {
        const service = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const id = rootStore.routerStore.routerState.params.id;

        super(rootStore, {
			name: "facility-inventory",
			id: id,
			Form: FacilityInventoryCountEditForm,
			authorization: 'portalSection.update',
			actions:  {
				get: async (id, opts) => {
					const response = await service.get(id, _.extend(opts, {
						embed: 'Facility,Person'
					}));
					this.form.update(response.data);

					return response.data;
				},
				update: async resource => {
					const response = await service.update(resource);

					return response.data;
				},
				create: async resource => {
					const response = await service.create(resource);
					
					return response.data;
				},
			},
			errorActions: {
				onCreateError: ({ error }) => {
					rootStore.notificationStore.error('FACILITY_INVENTORY.CREATE.ERROR', error);
				},
				onUpdateError: ({ error }) => {
					rootStore.notificationStore.error('FACILITY_INVENTORY.EDIT.ERROR', error);
				},
			},
			FormClass: FacilityInventoryCountEditForm,
		});

        this.service = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);

        this.facilityStore = new BaasicDropdownStore({
			filterable: true,
		}, {
			fetchFunc: async(term) => {
				const response = await facilityService.find({
					searchQuery: term,
					rpp: 50,
					inActive: false
			});
                return response.data.item;
			}
		});
    }

	@action
	setItem(item) {
        this.item = item;
        this.itemInitialized = true;
		this.facilityStore.setValue(item.facility);
    }

	@action.bound
	async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            const response = await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await setTimeout(() => this.notifySuccessCreate(), 10);

			this.rootStore.routerStore.goTo(
				'master.app.main.facility-inventory.facility-inventory-detail.list',
				{ facilityInventoryCountHeaderId: response.id, isDone: response.isDone }
			); 
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }
	
	@action.bound
	notifySuccessCreate() {
        this.rootStore.notificationStore.success('FACILITY_INVENTORY.CREATE.SUCCESS');
    }
    
    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_INVENTORY.EDIT.COUNT_DATE_SUCCESS', name);
    }
}

export default FacilityInventoryCountEditViewStore;
